
import Vue from 'vue';

/**
 * Scroll view component.
 *
 * Make scrollable vertically when the content is too big.
 */
export default Vue.extend({
  name: 'ScrollView',
  inheritAttrs: false
});
